jQuery.feature_import("js-wysiwyg",
  () => require("./wysiwyg.js"),
  mod => mod.feature_js_wysiwyg
);